import {connect} from 'react-redux';
import GroupMigrationView from '../../components/views/mx/GroupMigrationView';
import * as GroupActions from '../../actions/mx/GroupActions';
import {State} from '../../../types/mx/reducers';
import {GroupMigrationStateProps, GroupMigrationDispatchProps} from '../../types/mx/containers';
import * as ModalActions from '../../../../wizard/actions/ModalActions';
import {AnyAction, Dispatch} from 'redux';

const mapStateToProps = (state: State, ownProps): GroupMigrationStateProps => {
    const {groupId, name, groupList, creditsNumber, guaranteesNumber, quotationsNumber, insuranceNumber} =
        state.group.form;

    const migrationResult =  (ownProps.data && ownProps.data.migrationResult) ? ownProps.data.migrationResult : 0;
    const isSuccess =  (ownProps.data && ownProps.data.isSuccess) ? ownProps.data.isSuccess : false;

    return {
        migrationResult,
        isSuccess,
        originGroup: {id: groupId, value: name, payload: ''},
        targetGroup: groupList,
        numberRequests: creditsNumber + guaranteesNumber + quotationsNumber + insuranceNumber
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): GroupMigrationDispatchProps => {
    return {
        onPressMigrationConfirm: () => {
            dispatch(GroupActions.GROUP_MIGRATION_REQUEST_ACTION.action());
        },
        onPressClose: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        }
    };
};

const GroupMigrationContainer = connect(
    mapStateToProps, mapDispatchToProps
)(GroupMigrationView);

export default GroupMigrationContainer;